/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { VWQIcon } from "@sunwing/icons";
import config from "../../app/config";

let styles;

(async () => {
  if (config.isWestJetMode) {
    styles = await import("./helpfulinfoVwq.module.scss");
  } else {
    styles = await import("./helpfulinfo.module.scss");
  }
})();

const SectionCategories = ({
  currentSection,
  selectedInfo,
  selectedSection,
  setSelectedInfo,
  setSelectedSection,
}) => {
  const [expanded, setExpanded] = useState();

  const handleArrowClick = () => {
    setExpanded(!expanded);
  };

  const handleCategoryClick = (currentSection, info) => {
    setSelectedInfo(info);
    setSelectedSection(currentSection);
  };

  useEffect(() => {
    setExpanded(selectedSection.displayTitle === currentSection.displayTitle);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedInfo]);

  return (
    <div className={styles.sectionContainer}>
      <div className={styles.sectionHeader}>
        <button
          data-accordion="tab"
          id={`${selectedInfo.sys.id}-trigger`}
          className={styles.sectionButton}
          aria-controls={`${selectedInfo.sys.id}-content`}
          aria-expanded={expanded}
          onClick={() => handleArrowClick(currentSection)}
        >
          <span className={styles.sectionTitle}>
            {currentSection.displayTitle}
          </span>
          <span>
            {expanded ? (
              <VWQIcon name="chevron-up-micro" />
            ) : (
              <VWQIcon name="chevron-down-micro" />
            )}
          </span>
        </button>
      </div>
      {expanded && (
        <div
          data-accordion="content"
          className={styles.sectionContentMenu}
          tabIndex={expanded ? undefined : -1}
          role="region"
          id={`${selectedInfo.sys.id}-content`}
          aria-labelledby={`${selectedInfo.sys.id}-trigger`}
        >
          {currentSection.componentsCollection.map((info) => {
            return (
              <div>
                <button
                  onClick={() => {
                    handleCategoryClick(currentSection, info);
                  }}
                  className={`${styles.categoryButton} 
                    ${
                      info.displayTitle === selectedInfo.displayTitle &&
                      styles.categoryButtonSelected
                    }`}
                >
                  {info.displayTitle}
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SectionCategories;
